import React from 'react'
import { Link } from 'react-router-dom'
import './ComingSoon.css'

function ComingSoon() {
  return (
    <div className='comingSoon'>
       <div className="comingSoonTitle">
          <h1>Coming soon...</h1>
          <p><Link to={'/p/images'}>View pictures</Link></p>
       </div>
    </div>
  )
}

export default ComingSoon